
import { useSupabaseCount, CountResult } from "./useSupabaseCount";

export function useReviewCount(): CountResult {
  return useSupabaseCount("reviews", "review-count");
}
